import React, { useRef, useEffect } from 'react';
import format from 'date-fns/format';
import { decode } from 'html-decoder';
import Ratings from '../Ratings';

export default function ActiveMarker({ listing, type, changeActiveMarker }) {
  const activeCardRef = useRef(null);
  const isRental = type === 'rental';
  const isEvent = type === 'event';

  let backgroundImage;
  if (isRental) {
    backgroundImage = listing.image_url;
  } else {
    backgroundImage =
      listing.small_featured_image_url ||
      listing.medium_featured_image_url ||
      listing.featured_image_url;
  }

  let link;
  if (isRental) {
    link = listing.property_url;
  } else if (isEvent) {
    link = window.Routes.event_path(listing);
  } else {
    link = window.Routes.listing_type_show_path({
      area: listing.city_name,
      is_type: listing.is_type,
      category:
        typeof listing.category === 'string'
          ? listing.category
          : listing.category.slug || listing.category.name.split(' ').join('-'),
      url: listing.slug,
    });
  }

  useEffect(() => {
    const handleClick = e => {
      if (activeCardRef.current && !activeCardRef.current.contains(e.target)) {
        changeActiveMarker(null);
      }
    };

    document.addEventListener('click', handleClick);

    return () => document.removeEventListener('click', handleClick);
  }, [changeActiveMarker]);

  // Update z-index after animation is finished to re-render map components
  useEffect(() => {
    setTimeout(() => {
      document.querySelector('.active-marker-card').style.zIndex = 41;
    }, 1000);
  }, []);

  return (
    <div className="active-marker-card" ref={activeCardRef}>
      <a
        aria-label={`View ${isRental ? listing.name : listing.title}`}
        href={link}
        className={`image-section ${!backgroundImage ? 'no-image' : ''}`}
        style={{
          backgroundImage: backgroundImage && `url("${backgroundImage}")`,
        }}
      >
        <div className="image-overlay" />
        {!isEvent ? (
          <Ratings
            rating={listing.rating}
            rating_count={listing.rating_count}
          />
        ) : (
          <h3 className="active-marker-title">
            {format(listing.start_date, 'MMM DD')}
          </h3>
        )}
        {isRental && (
          <h3 className="active-marker-price">
            {listing.nightly_rate ? `$${listing.nightly_rate}` : 'Inquire'}
          </h3>
        )}
      </a>
      <div className="rental-details">
        {!isRental && (
          <p className="category">
            {isEvent
              ? listing.category.replace(/_/g, ' ')
              : listing.category.name}
          </p>
        )}
        {isRental && <p className="property-type">{listing.property_type}</p>}
        <h4 style={{ marginBottom: listing.price ? '0px' : '2px' }}>
          <a
            aria-label={`View ${isRental ? listing.name : listing.title}`}
            href={link}
          >
            {decode(isRental ? listing.name : listing.title)}
          </a>
        </h4>
        {isEvent && <p>{listing.start_time || 'All Day'}</p>}
        {isRental && (
          <p>
            {listing.nightly_rate
              ? `Starting from $${listing.nightly_rate}/night`
              : 'Inquire for Rates'}
          </p>
        )}
        {/* TODO: Change to be conditional for rental vs listing */}
        {isRental && (
          <p>
            {listing.beds && `${listing.beds || 'X'}br | `}
            {listing.baths && `${listing.baths || 'X'} ba | `}
            {listing.sleeps && `Sleeps ${listing.sleeps || 'X'}`}
          </p>
        )}
      </div>
    </div>
  );
}
